<template>
  <v-dialog v-model="dialog" max-width="590">
    <template v-slot:activator="{ on }">
      <v-btn block depressed color="secondary" v-on="on">
        <v-icon small>save_alt</v-icon>QR code stickers
      </v-btn>
    </template>
    <v-card v-if="dialog && stickerTemplate" class="container">
      <v-card-text>
        <v-list subheader two-line flat>
          <v-subheader>QR code stickers</v-subheader>

          <v-list-item-group v-model="type">
            <v-list-item>
              <template v-slot:default="{ active }">
                <v-list-item-action>
                  <v-checkbox v-model="active" color="primary" @click="active = !active"></v-checkbox>
                </v-list-item-action>

                <v-list-item-content>
                  <v-list-item-title>{{$t('withlogo')}}</v-list-item-title>
                  <v-list-item-subtitle>
                    <a
                      @click="dialog = false; $router.push({name: 'Profile'})"
                    >{{$t('addyourownlogo')}}</a>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-list-item>
               <v-list-item>
              <template v-slot:default="{ active }">
                <v-list-item-action>
                  <v-checkbox v-model="active" color="primary" @click="active = !active"></v-checkbox>
                </v-list-item-action>

                <v-list-item-content>
                  <v-list-item-title>{{$t('csv')}}</v-list-item-title>
                  <v-list-item-subtitle></v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-list-item>
            <v-list-item>
              <template v-slot:default="{ active }">
                <v-list-item-action>
                  <v-checkbox v-model="active" color="primary" @click="active = !active"></v-checkbox>
                </v-list-item-action>

                <v-list-item-content>
                  <v-list-item-title>{{$t('withoutlogo')}} 35x35</v-list-item-title>
                  <v-list-item-subtitle></v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-list-item>
            <v-list-item>
              <template v-slot:default="{ active }">
                <v-list-item-action>
                  <v-checkbox v-model="active" color="primary" @click="active = !active"></v-checkbox>
                </v-list-item-action>

                <v-list-item-content>
                  <v-list-item-title>{{$t('withoutlogo')}} 25x25</v-list-item-title>
                  <v-list-item-subtitle></v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-list-item>
          </v-list-item-group>
        </v-list>
        <v-select outlined dense v-model="amount" :items="items" :label="$t('amount')"></v-select>
      </v-card-text>
      <v-card-actions>
        <v-btn
          color="primary"
          block
          :disabled="amount == null"
          depressed
          @click="downloadStickers()"
        >{{$t('download')}}</v-btn>
      </v-card-actions>
    </v-card>
    <loadingDialog :dialog="loading"></loadingDialog>
  </v-dialog>
</template>


<script>
export default {
  data() {
    return {
      dialog: false,
      items: [10, 20, 30, 40, 50, 100, 200],
      amount: null,
      type: 0,
      loading: false,
      stickerTemplate: null,
      firelogLogo: require("@/assets/logo.png")
    };
  },
  // created(){
  //   this.getLogo();
  // },
  // mounted() {
  //   this.$nextTick(() => {
  //     this.getLogo();
  //   });
  // },
  watch: {
    dialog() {
      if (this.dialog) {
        if (this.stickerTemplate === null) {
          this.getLogo();
        }
      }
    },
  },
  methods: {
    uploadLogo() {
      let form = new FormData();
      form.append("logo", this.$refs.file.files[0]);

      this.$http
        .uploadLogo(form)
        .then(res => {
          this.stickerTemplate = res.data;
          this.$noty.success('<i class="fas fa-check"></i>');
        })
        .catch(err => {
          this.$noty.error(this.$t("error"));
          console.log(err);
        });
    },
    getLogo() {
      this.$http
        .getStickerTemplate()
        .then(res => {
          this.stickerTemplate = res.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    downloadStickers() {
      if (this.amount) {
        this.loading = true;
        this.$http
          .downloadQRStickers(this.amount, this.type)
          .then(res => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement("a");
            link.href = url;
            let date = new Date();
            if (this.type === 1) {
              link.setAttribute(
                "download",
                `QRcode_Stickers${date.toLocaleDateString()}.csv`
              );
            } else {
              link.setAttribute(
                "download",
                `QRcode_Stickers${date.toLocaleDateString()}.docx`
              );
            }
            document.body.appendChild(link);
            link.click();
            this.dialog = false;
            this.loading = false;
          })
          .catch(err => {
            this.$noty.error(this.$t("error"));
            console.log(err);
            this.loading = false;
          });
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/DownloadStickers.vue